import { createSignal } from "solid-js";

const [sidebarOpen, setSidebarOpen] = createSignal(false);

export function useMobileSidebar() {
  return {
    sidebarOpen,
    toggleSidebar: () => setSidebarOpen(prev => !prev),
    closeSidebar: () => setSidebarOpen(false),
  };
}
